import * as React from 'react';
import { ActionIcon, Flex } from "@mantine/core";
import { IconArrowDown, IconArrowLeft, IconArrowRight, IconArrowUp } from "@tabler/icons-react";

interface ScrollControlProps {
    vertical?: React.RefObject<HTMLElement>;
    horizontal?: React.RefObject<HTMLElement>;
}

const ScrollControl = ({
    horizontal,
    vertical
}: ScrollControlProps) => {

    const scrollButtonClick = (dir: 'left' | 'right' | 'up' | 'down') => {
        switch (dir) {
            case 'up': {
                vertical?.current?.scrollTo?.({
                    top: 0,
                    behavior: 'smooth'
                })
                break;
            }
            case 'down': {
                vertical?.current?.scrollTo?.({
                    top: vertical.current.scrollHeight,
                    behavior: 'smooth'
                })
                break;
            }
            case 'left': {
                horizontal?.current?.scrollTo?.({
                    left: 0,
                    behavior: 'smooth'
                })
                break;
            }
            case 'right': {
                horizontal?.current?.scrollTo?.({
                    left: horizontal.current.scrollWidth,
                    behavior: 'smooth'
                })
                break;
            }
        }
    }

    return (
        <Flex
            gap="xs"
            justify="flex-start"
            align="center"
            direction="row"
            wrap="wrap"
        >
            <ActionIcon onClick={() => scrollButtonClick('up')} variant='filled' size='sm' color='color-primary'>
                <IconArrowUp/>
            </ActionIcon>
            <ActionIcon onClick={() => scrollButtonClick('down')} variant='filled' size='sm' color='color-primary'>
                <IconArrowDown/>
            </ActionIcon>
            <ActionIcon onClick={() => scrollButtonClick('left')} variant='filled' size='sm' color='color-primary'>
                <IconArrowLeft/>
            </ActionIcon>
            <ActionIcon onClick={() => scrollButtonClick('right')} variant='filled' size='sm' color='color-primary'>
                <IconArrowRight/>
            </ActionIcon>
        </Flex>
    )
};

export default ScrollControl;